import type { ItemAttributeSimpleValueEntity } from './ItemAttributeSimpleValueEntity'
import type { ItemAttributeTranslationEntity } from './ItemAttributeTranslationEntity'
import type { ItemMiniEntity } from './ItemMiniEntity'

export class ItemAttributeEntity {
  id?: string
  order?: number

  translations?: Array<ItemAttributeTranslationEntity>
  simpleValues?: Array<ItemAttributeSimpleValueEntity> | null
  itemValues?: Array<ItemMiniEntity> | null
  minOption?: number
  maxOption?: number
}
